module.exports = __webpack_public_path__ + "static/media/barrier_breaker_thumb_home.9cc61a80.mp4";